var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWashHand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.25 7.77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313332"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.36 5-.44-.09a.54.54 0 0 0 -.58.18l-.1.11.37.37a.57.57 0 0 0 .11-.11.16.16 0 0 1 .09 0l.42.13-.4 1.64h-4.41l-.24-1a3.57 3.57 0 0 1 .69-.63.2.2 0 0 1 .18 0 2.61 2.61 0 0 0 1.25.53 3 3 0 0 0 .32-.12l-.62-.38c-.26 0-.29-.17-.71-.44a.76.76 0 0 0 -.6-.1 1.92 1.92 0 0 0 -.7.53l-.47-2.13-.52.12 1 4.16h5.25l1-4.11-.52-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.89 2.12.11-.02.2.17a.4.4 0 0 1 .14.26l.15 1.65a1.77 1.77 0 0 0 .51 1.02l2.23 1.64a.2.2 0 0 0 .27 0 .73.73 0 0 0 -.07-1l-.78-.74a.89.89 0 0 0 .13-.82l-.31-.89a1 1 0 0 1 0-.41v-.15a1.74 1.74 0 0 0 -.55-1.43h.11a.2.2 0 0 0 .12-.25l-.35-1.02a.19.19 0 0 0 -.25-.13l-2.14.77a.2.2 0 0 0 -.12.23l.34 1a.21.21 0 0 0 .26.12zm2.11.67v.11a1.26 1.26 0 0 0 .07.58l.31.89a.47.47 0 0 1 -.13.5l-.43-1.2a.2.2 0 0 0 -.38.14l.56 1.45a.21.21 0 0 0 .26.13l.11-.06.8.76a.31.31 0 0 1 .1.25l-2-1.45a1.33 1.33 0 0 1 -.39-.76l-.19-1.64a.85.85 0 0 0 -.27-.49l1.1-.39a1.34 1.34 0 0 1 .48 1.18zm-.51-2.33.21.59-1.7.62-.21-.59z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWashHand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "WashHand.34fd613825848445c241057ffcb008e7.svg";